import { useDeleteV2 } from "../../company-configurtaion/hooks"

export function useDeleteConfigType() {
    const {
        mutateAsync: deleteConfigType,
        isLoading: isDeleting,
        error
    } = useDeleteV2({
        url: 'config/type',
        msg: 'deleted successfully',
        apiVersion: 'v1'
    })
    
    return {
        deleteConfigType,
        isDeleting,
        error,
    }
}
